<template>
  <div v-if="nodes.length > 0">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>审批流程</span>
      </div>
      <el-steps direction="vertical" :active="step.length" finish-status="success">
        <el-step v-for="(item,index) in nodes" :key=index>
          <template #title>
            <div style="height: 50px">审批人: {{ item.userName }}</div>
          </template>
        </el-step>
      </el-steps>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Setp",
  props: {
    "nodes": Array,
    "audits": Array
  },
  data() {
    return {
      step: []
    }
  },
  watch: {
    audits(n) {
      let arr = []
      for (let item of n) {
        if (item.isAgree === 2) {
          arr.push(item)
        }
      }
      this.step = arr
    }
  }
}
</script>

<style scoped>
.box-card {
  width: 250px;
  position: fixed;
  right: 0;
  top: 160px;
  min-height: 50px;
  z-index: 9999999;
}
</style>
